import {
    dateFormatter,
} from 'common/utils/valueFormatters';
import { clockStyle } from 'common/utils/styleChooser';

export const signInGridColumns = [
    {
        field: 'clockDate',
        headerName: 'Clock Date',
        valueFormatter: dateFormatter,
        cellClass: 'keywork',
        enableRowGroup: true,
        rowGroup: true,
        hide: true,
        width: 70,
    },
    {
        field: 'type',
        headerName: 'Type',
        cellClass: 'non-number',
        enableRowGroup: true,
        cellRenderer: 'tagComponent',
        cellRendererParams: {
            colorMap: {
                Clock: 'green',
                Vacation: 'yellow',
                Holiday: 'white'
            }
        },
        width: 70,
    },
    {
        field: 'createdBy',
        headerName: 'Clock By',
        cellClass: 'keyword',
        enableRowGroup: true,
        width: 70,
    },
    {
        field: 'workHours',
        headerName: 'Hours',
        cellClass: 'number',
        width: 70,
    },
     {
        field: 'approvedHours',
        headerName: 'Extra Hours',
        cellClass: 'number',
        width: 70,
    },
    {
        field: 'exceedHours',
        headerName: 'Exceed Hours',
        cellClass: 'number',
        width: 70,
    },
    {
        field: 'isExceed',
        headerName: 'Exceed',
        cellClassRules: clockStyle(),
        width: 70,
    },
    {
        field: 'clockIn',
        headerName: 'ClockIn Time',
        width: 120,
    },
    {
        field: 'clockOut',
        headerName: 'ClockOut Time',
        width: 120,
    },
];

export const signApprovedGridColumns = [
    {
        field: 'status',
        headerName: 'Status',
        cellClass: 'non-number',
        enableRowGroup: true,
        rowGroup: true,
        width:70,
    },
    {
        field: 'type',
        headerName: 'Operation',
        cellClass: 'keyword',
        width:50,
    },
    {
        field: 'clockDate',
        headerName: 'Clock Date',
        width:70,
    },
    {
        field: 'remark',
        headerName: 'Remark',
        width:130,
    },
    {
        field: 'feedback',
        headerName: 'Feedback',
        cellClass: 'non-number',
        width:130,
    },
    {
        field: 'createdBy',
        headerName: 'Clock By',
        width:70,
    },
    {
        field: 'createdOn',
        headerName: 'Clock Time',
        width:120,
    },
];


export const extraHoursGridColumns = [
    {
        field: 'status',
        headerName: 'Status',
        cellClass: 'non-number',
        enableRowGroup: true,
        rowGroup: true,
        hide: true,
        // cellRendererParams: {
        //     colorMap: {
        //         NEW: 'green',
        //         REJECTED: 'red',
        //         PASS: '#FF9E28'
        //     }
        // },
        width: 70,
    },
    {
        field: 'createdBy',
        headerName: 'Clock By',
        cellClass: 'keyword',
        enableRowGroup: true,
        width: 80,
    },
    {
        field: 'date',
        headerName: 'Date',
        cellClass: 'keyword',
        width: 70,
    },
    {
        field: 'applyHours',
        headerName: 'Extra Hours',
        cellClass: 'number',
        width: 70,
    },

    {
        field: 'remark',
        headerName: 'Remark',
        width: 130,
    },
    {
        field: 'feedback',
        headerName: 'Feedback',
        cellClass: 'non-number',
        width: 130,
    }
]